module.exports = __webpack_public_path__ + "img/sintesis.45599485.svg";